import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Row, Col } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { updateShape } from '../../Reducers/mileSpaceSlice';
import ShapeTable from '../ShapesTable';
import { getPointLabels } from '../../Utils/localStorageUtils';
import './shapeForm.css';
import DynamicField from '../DynamicFormFeilds';
import { updateSpace } from '../../Services/spaceServices';
import { useParams } from 'react-router-dom';
import { setIsDocumentChanged } from '../../Reducers/documentInfoSlice';

const ShapeForm = ({ formValues, setFormValues, onCancel }) => {
  
  const { id } = useParams();
  const dispatch = useDispatch();
  const shapes = useSelector((state) => state.mileSpace.spaceData.shapes);
  const isReadOnly = useSelector((state) => state.documentData.isReadOnly);
  const [dynamicFields, setDynamicFields] = useState([]);
  const spaceData = useSelector((state) => state.mileSpace.spaceData);

  useEffect(() => {
    const shapeId = formValues.id;
    const shape = shapes && shapes.find((shape) => shape.id === shapeId);
    if (shape && Array.isArray(shape.dynamicFields)) {
      setDynamicFields(shape.dynamicFields);
    } else {
      setDynamicFields([]);
    }
  }, [formValues.id]);

  const handleInputChange = (e) => {
    setFormValues((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleDynamicFieldValueChange = (index, value) => {
    setDynamicFields((prevFields) =>
      prevFields.map((field, i) =>
        i === index ? { ...field, value } : field
      )
    );
  };

  const handleDynamicFieldLabelChange = (index, label) => {
    setDynamicFields((prevFields) =>
      prevFields.map((field, i) =>
        i === index ? { ...field, label } : field
      )
    );
  };

  const addDynamicField = () => {
    setDynamicFields((prevFields) => [...prevFields, { label: '', value: '' }]);
  };

  const removeDynamicField = (index) => {
    setDynamicFields((prevFields) => prevFields.filter((_, i) => i !== index));
  };

  const handleSaveShapeDetails = () => {
    const updatedShape = { ...formValues, dynamicFields };
    dispatch(updateShape(updatedShape));
    // Update shapes in local storage
    const updatedShapes = shapes.map((shape) =>
      shape.id === updatedShape.id ? updatedShape : shape
    );
    dispatch(updateSpace({
      id,
      updatedData:{
          ...spaceData,
          shapes:updatedShapes
      }
  }));
    onCancel();
    dispatch(setIsDocumentChanged(true));
  };

  return (
    <Form layout="vertical">
      {['Name', 'Description', 'Length', 'Dimensions'].map((field) => (
        <Form.Item key={field} className='mb-6'>
          <Row className="form-item-row" gutter={8}>
            <Col className="form-item-label" span={6}>
              <span>{field}:</span>
            </Col>
            <Col className="form-item-input" span={18}>
              {field === 'Description' ? (
                <Input.TextArea
                  name={field}
                  value={formValues[field]}
                  onChange={handleInputChange}
                  readOnly={isReadOnly}
                  rows={4}
                  placeholder={`Enter ${field.toLowerCase()}`}
                />
              ) : (
                <Input
                  name={field}
                  value={formValues[field]}
                  onChange={handleInputChange}
                  readOnly={isReadOnly}
                  placeholder={`Enter ${field.toLowerCase()}`}
                />
              )}
            </Col>
          </Row>
        </Form.Item>
      ))}

      {Array.isArray(getPointLabels(formValues)) && getPointLabels(formValues).map((label, index) => (
        <Form.Item key={label} className='mb-6'>
          <Row gutter={8}>
            <Col className="form-item-label" span={6}>
              <span>{label}:</span>
            </Col>
            <Col span={18}>
              <Input
                name={`point_${index}`}
                value={formValues[`point_${index}`]}
                onChange={handleInputChange}
                readOnly={isReadOnly}
                placeholder={`Value for point ${label}`}
                style={{ width: '100%' }}
              />
            </Col>
          </Row>
        </Form.Item>
      ))}

      {/* Render dynamic fields using DynamicField component */}
      {Array.isArray(dynamicFields) && dynamicFields.map((field, index) => (
        <DynamicField
          key={`dynamic_${index}`}
          index={index}
          value={field.value}
          label={field.label}
          onValueChange={handleDynamicFieldValueChange}
          onLabelChange={handleDynamicFieldLabelChange}
          onRemove={removeDynamicField}
          isReadOnly={isReadOnly}
        />
      ))}

      {/* Button to add a new dynamic field */}
      <Button className='mb-6' type="dashed" onClick={addDynamicField} disabled={isReadOnly}>
        Add Dynamic Field
      </Button>

      {Array.isArray(formValues.images) && formValues.images.length > 0 && (
        <Form.Item label='Shapes' className='mb-6'>
          <ShapeTable formValues={formValues} />
        </Form.Item>
      )}

      <div className="form-buttons">
        <Button
          type="primary"
          onClick={handleSaveShapeDetails}
          className="save-button"
          disabled={isReadOnly}
        >
          Save
        </Button>
        <Button onClick={onCancel} className="cancel-button">
          Cancel
        </Button>
      </div>
    </Form>
  );
};

export default ShapeForm;